export enum TileCategory {
  EXPERIMENTAL = 'EXPERIMENTAL',
  BASIC = 'BASIC',
  CONTENT = 'CONTENT',
  CONTENT_DISPLAY = 'CONTENT_DISPLAY',
  PAGE_CONETENT = 'PAGE_CONETENT',
  POPULAR = 'POPULAR',
  FLEXIBLE = 'FLEXIBLE',
  HEADER = 'HEADER',
  EMBED = 'EMBED',
  GENERAL = 'GENERAL',
  FILE_MANAGEMENT = 'FILE_MANAGEMENT',
  PROJECT_MANAGEMENT = 'PROJECT_MANAGEMENT',
  POPULAR_TEMPLATES = 'POPULAR_TEMPLATES',
  NAVIGATION_AND_CTA = 'NAVIGATION_AND_CTA',
  TEXT_AND_MEDIA = 'TEXT_AND_MEDIA',
  AI_AGENTS = 'AI_AGENTS',
  CUSTOM = 'CUSTOM',
  DYNAMIC = 'DYNAMIC',
}

export enum TileType {
  INFO_BLOCK,
  CUSTOM,
  CHAT,
  TASK,
  PAGE,
  GOOGLE_DRIVE,
  MICROSOFT_DOC,
  CALENDLY,
  YOUTUBE,
  AIRTABLE,
  LOOM,
  DATA_STUDIO,
  FIGMA,
  MIRO,
  HUBSPOT,
  SECTION,
  PROCESS,
  EXTERNAL_LINK,
  NIMBUS_CONTENT,
  BLANK_PAGE,
  FILES_DASHBOARD,
  FILES_RECENT,
  FILES_BUCKET,
  FLEXIBLE,
  TASKS_DASHBOARD,
  CHAT_DASHBOARD,
  EMBEDS,
  ONBOARDING,
  WELCOME_PAGE,
  FAQ,
  FLOW_GUIDES,
  KANBAN,
  TASK_LIST,
  TABLE,
  TEMPLATE,
}

export type NoteCreateTileType =
  | TileType.ONBOARDING
  | TileType.WELCOME_PAGE
  | TileType.FAQ
  | TileType.FLOW_GUIDES
  | TileType.KANBAN
  | TileType.TASK_LIST
  | TileType.TABLE
  | TileType.BLANK_PAGE;
